interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={`flex flex-col gap-3 ${isCenter ? 'items-center text-center' : 'items-start'}`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
        <i className="ri-price-tag-3-line"></i>
        {eyebrow}
      </span>
      <h2 className="font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
        {title}
      </h2>
      <p className={`max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base ${isCenter ? 'mx-auto' : ''}`}>
        {desc}
      </p>
    </div>
  );
}